import * as React from 'react';
import { LabSimAppUrl } from '../Environment';

interface IDemoAccessProps {

}

interface IDemoAccessState {
    tether?: string;
}

export default class DemoTestDev extends React.PureComponent<IDemoAccessProps, IDemoAccessState> {
    constructor(props: IDemoAccessProps) {
        super(props);
        this.state = {};
    }

    componentWillMount() {
        window.onmessage = (e: MessageEvent) => {
            window.location.assign("https://labsimapp-test.testout.com");
        }
        let tether = encodeURIComponent(btoa(`{"login":"demoaccess_3f4c15d2-cf15-4cdc-9563-f13af3ba186c","pHash":"92fa269016705f3cac3474ff323f918d8790eb0450cd3cc4c7d5c60676d7bf46","source":"${window.location.protocol}//${window.location.host}","sales_contact":""}`));
        this.setState({ tether: `https://labsimapp-test.testout.com/?tetheredstart=${tether}` });
    }

    render() {
        return <div>
            <div className="spinner-border text-warning" style={{ "width": "10rem", "height": "10rem", "position": "absolute", "left": "calc(50% - 80px)", "top": "calc(50% - 125px)" }} role="status">
                <span className="sr-only">Loading...</span>
            </div>
            <iframe src={this.state.tether} style={{ "display": "none" }} />
        </div>;
    }
}